import React, { Component } from 'react';

import './style.css';


export default class ConfirmEvent extends Component {
  render() {
    const classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
    return (
      <div className={classes + ' form__info-block'}>
        <div className='form__tips'>
          Этой весной будет 2&nbsp;направления: для школьников или для тех, кто первый раз на&nbsp;HappyDev-lite, и&nbsp;тех, кто уже был на&nbsp;конференции.
        </div>
        <div className='form__inputs'>
          <label className='form__label'>Пожалуйста, выберите:</label>
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/form-blocks/ConfirmEvent.js